// extracted by mini-css-extract-plugin
module.exports = {"applicationSection":"application-section-module--application-section--1wTfT section-module--margin--4b_tv"};